import { agentFomoDomain } from "../../constants.ts";
import type { PublicStats, PublicStatsFilters } from "../../src/publicStats.ts";

export const fetchPublicStats = async (
  filters: PublicStatsFilters,
): Promise<PublicStats> => {
  const params = new URLSearchParams();
  if (filters.country) params.set("country", filters.country);
  if (filters.categories && filters.categories.length > 0) {
    params.set("categories", filters.categories.join(","));
  }
  const query = params.toString();
  const response = await fetch(
    `https://${agentFomoDomain}/public/stats${query ? `?${query}` : ""}`,
  );
  if (!response.ok) throw new Error("Failed to load stats");
  return response.json();
};
